(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mnl-article-interactive"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mnl-article-exercise')) {
  customElements.define('mnl-article-exercise', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      if (this.dataset.exercise === 'compare') this.setupComparison(signal);
      if (this.dataset.exercise === 'journal') this.setupChecklist(signal);
      if (this.dataset.exercise === 'quiz') this.setupQuiz(signal);
    }
    disconnectedCallback() { this.controller?.abort(); }
    setupComparison(signal) {
      const form = this.querySelector('[data-comparison]');
      const error = form.querySelector('[data-error]');
      const results = form.querySelector('[data-results]');
      const fields = [...form.querySelectorAll('input')];
      error.id = `${this.id}-error`;
      const format = new Intl.NumberFormat(this.lang || document.documentElement.lang || 'fr', { maximumFractionDigits: 2 });
      const scientific = new Intl.NumberFormat(this.lang || document.documentElement.lang || 'fr', { notation: 'scientific', maximumFractionDigits: 2 });
      const displayNumber = (value) => value !== 0 && value < 0.01 ? scientific.format(value) : format.format(value);
      const clear = () => { error.textContent = ''; fields.forEach((field) => { field.removeAttribute('aria-invalid'); field.setAttribute('aria-describedby', `${this.id}-number-note`); }); };
      form.addEventListener('input', () => { clear(); results.hidden = true; }, { signal });
      form.addEventListener('reset', () => { clear(); results.hidden = true; }, { signal });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        clear();
        results.hidden = true;
        let invalid = null;
        let message = '';
        const pairs = [...form.querySelectorAll('.mnl-aix__product')].map((fieldset) => {
          const pair = [...fieldset.querySelectorAll('input')];
          const numbers = pair.map((field) => {
            const raw = field.value.trim();
            const value = /^\d+(?:[.,]\d+)?$/.test(raw) ? Number(raw.replace(',', '.')) : NaN;
            if (!Number.isFinite(value) && !invalid) { invalid = field; message = form.querySelector(raw ? '[data-error-number]' : '[data-error-empty]').textContent; }
            return value;
          });
          if (!invalid && (numbers[0] <= 0 || numbers[1] < 0 || numbers[1] > numbers[0] || !Number.isFinite(numbers[1] * 1000))) {
            invalid = numbers[0] <= 0 ? pair[0] : pair[1];
            message = form.querySelector('[data-error-range]').textContent;
          }
          return numbers;
        });
        if (invalid) {
          error.textContent = message;
          invalid.setAttribute('aria-invalid', 'true');
          invalid.setAttribute('aria-describedby', `${this.id}-number-note ${error.id}`);
          invalid.focus();
          return;
        }
        pairs.forEach(([portion, ingredient], index) => {
          const result = results.querySelector(`[data-result="${index + 1}"]`);
          result.querySelector('[data-milligrams]').textContent = displayNumber(ingredient * 1000);
          result.querySelector('[data-concentration]').textContent = displayNumber(ingredient / portion * 1000);
          result.querySelector('[data-bar]').style.setProperty('--ingredient-share', `${ingredient / portion * 100}%`);
        });
        results.hidden = false;
      }, { signal });
      form.hidden = false;
    }
    setupChecklist(signal) {
      const form = this.querySelector('[data-checklist]');
      const progress = form.querySelector('[data-progress]');
      const steps = [...form.querySelectorAll('[data-step]')];
      const update = () => { progress.textContent = progress.dataset.template.replace('__COUNT__', String(steps.filter((step) => step.checked).length)); };
      form.addEventListener('change', update, { signal });
      form.addEventListener('reset', () => { steps.forEach((step) => { step.checked = false; }); update(); }, { signal });
      form.querySelector('[data-enhanced]').hidden = false;
      update();
    }
    setupQuiz(signal) {
      const form = this.querySelector('[data-quiz]');
      const questions = [...form.querySelectorAll('[data-quiz-question]')];
      const error = form.querySelector('[data-error]');
      const score = form.querySelector('[data-score]');
      error.id = `${this.id}-error`;
      const clear = () => {
        error.textContent = '';
        score.textContent = '';
        questions.forEach((question) => {
          question.querySelector('[data-answer]').hidden = true;
          question.querySelectorAll('input').forEach((input) => { input.removeAttribute('aria-invalid'); input.removeAttribute('aria-describedby'); });
        });
      };
      form.addEventListener('change', clear, { signal });
      form.addEventListener('reset', clear, { signal });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        clear();
        const missing = questions.find((question) => !question.querySelector('input:checked'));
        if (missing) {
          error.textContent = form.querySelector('[data-quiz-missing]').textContent;
          const input = missing.querySelector('input');
          input.setAttribute('aria-invalid', 'true');
          input.setAttribute('aria-describedby', error.id);
          input.focus();
          return;
        }
        let correctCount = 0;
        questions.forEach((question) => {
          const selected = question.querySelector('input:checked');
          const correct = selected.dataset.correct === 'true';
          if (correct) correctCount += 1;
          const answer = question.querySelector('[data-answer]');
          answer.querySelector('[data-verdict]').textContent = form.querySelector(correct ? '[data-quiz-correct]' : '[data-quiz-review]').textContent;
          answer.hidden = false;
          question.querySelectorAll('input').forEach((input) => input.setAttribute('aria-describedby', answer.id));
        });
        score.textContent = score.dataset.template.replace('__COUNT__', String(correctCount));
      }, { signal });
      form.hidden = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-atelier-discovery"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.MNLAtelierDiscovery) { window.MNLAtelierDiscovery.boot(document); return; }
  const instances = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const format = new Intl.NumberFormat(document.documentElement.lang || 'fr', { maximumFractionDigits: 2 });
  const unitFormat = new Intl.NumberFormat(document.documentElement.lang || 'fr', { maximumSignificantDigits: 12 });
  const tinyUnitFormat = new Intl.NumberFormat(document.documentElement.lang || 'fr', { notation: 'scientific', maximumSignificantDigits: 12 });
  function mount(root) {
    if (instances.has(root)) return;
    const tabs = Array.from(root.querySelectorAll('[data-at-ex-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-at-ex-panel]'));
    const grams = root.querySelector('[data-at-ex-grams]');
    const portions = root.querySelector('[data-at-ex-portions]');
    const uses = root.querySelector('[data-at-ex-uses]');
    if (tabs.length !== 3 || panels.length !== 3 || !grams || !portions || !uses) return;
    const controller = new AbortController();
    let animation;
    function stop() { if (animation) { animation.cancel(); animation = null; } }
    function select(index, focus, animate) {
      stop();
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        panels[i].hidden = i !== index;
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].setAttribute('aria-labelledby', tab.id);
        panels[i].tabIndex = 0;
      });
      if (focus) tabs[index].focus();
      if (animate && !reduced.matches && panels[index].animate) animation = panels[index].animate([{ opacity: .6, transform: 'translateY(6px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 180, easing: 'ease-out' });
    }
    function update() {
      const amount = Number(grams.value);
      const validAmount = grams.value.trim() !== '' && Number.isFinite(amount) && amount >= 0 && amount <= 1000;
      grams.setAttribute('aria-invalid', String(!validAmount));
      const milligrams = amount * 1000;
      const formatter = milligrams !== 0 && Math.abs(milligrams) < 0.000001 ? tinyUnitFormat : unitFormat;
      root.querySelector('[data-at-ex-milligrams]').textContent = validAmount ? formatter.format(milligrams) : '—';
      const count = Number(portions.value), weekly = Number(uses.value);
      root.querySelector('[data-at-ex-portions-value]').textContent = format.format(count);
      root.querySelector('[data-at-ex-uses-value]').textContent = format.format(weekly);
      const validDuration = Number.isFinite(count) && Number.isFinite(weekly) && count >= 15 && count <= 60 && weekly >= 1 && weekly <= 7;
      root.querySelector('[data-at-ex-weeks]').textContent = validDuration ? format.format(count / weekly) : '—';
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index, false, true), { signal: controller.signal });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); select(next, true, true);
      }, { signal: controller.signal });
    });
    [grams, portions, uses].forEach(input => { input.disabled = false; input.addEventListener('input', update, { signal: controller.signal }); });
    select(0, false, false); update();
    root.querySelector('[data-at-ex-tabs]').hidden = false;
    instances.set(root, { stop, update, destroy() { stop(); controller.abort(); instances.delete(root); } });
  }
  function boot(scope) { if (scope.matches?.('[data-at-discovery]')) mount(scope); scope.querySelectorAll('[data-at-discovery]').forEach(mount); }
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => { instances.forEach((instance, root) => { if (event.target.contains(root)) instance.destroy(); }); });
  reduced.addEventListener('change', () => { if (reduced.matches) instances.forEach(instance => instance.stop()); });
  window.addEventListener('pagehide', () => instances.forEach(instance => instance.stop()));
  window.addEventListener('pageshow', () => instances.forEach(instance => instance.update()));
  window.MNLAtelierDiscovery = { boot };
  boot(document);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-atelier-motion-v1484"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if (!document.body.classList.contains('mnl-atelier')) return;
  if (window.MNLAtelierKinetics) { window.MNLAtelierKinetics.scan(document); return; }
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const photoReveal = '[data-mnl-photo-reveal]';
  const selector = '.at-specs > div, .at-ex__heading, .at-ex__tabs, .at-sports > a, ' +
    '.at-formulas__header, .at-formulas__card, .at-practice__heading, .at-campaign-card, ' +
    '.mnl-product-guide__header, .mnl-product-guide__visual, .mnl-product-guide__steps > li, .mnl-product-guide__choices, ' + photoReveal;
  const photos = '#mnl-pp3-gal-img, #mnl-pp3-lightbox-img';
  const disclosures = 'details.at-formulas__details, details.mnl-faq__item, details.mnl-pp3-faqlite__item, details.mnl-pp3-faq__item, details.mnl-pp3-megapanel';
  const disclosureContent = '.at-formulas__ingredients, .mnl-faq__a, .mnl-pp3-faqlite__a, .mnl-pp3-faq__a, .mnl-pp3-megapanel__body';
  const seen = new WeakSet();
  const observed = new Set();
  const photoSources = new WeakMap();
  const openStates = new WeakMap();
  const photoOwners = new WeakMap();
  const seenPhotos = new WeakSet();
  const active = new Map();
  let suspended = false;
  function allowed() { return !reduced.matches && !document.hidden && !suspended; }
  function ownsEntrance(element) {
    if (element.closest('[data-at-reveal], [data-mnl-reveal], .mnl-reveal')) return false;
    const owner = element.closest(photoReveal);
    if ((owner && owner !== element) || (!owner && element.querySelector(photoReveal))) return false;
    if (owner && (element.tagName === 'IMG' || element.closest('.at-hero-banner, .at-hero, [data-mnl-lcp]') ||
        (element.parentElement && element.parentElement.closest(photoReveal)))) return false;
    return true;
  }
  function play(element, frames, options) {
    if (!allowed() || !element.isConnected || typeof element.animate !== 'function') return;
    // Never move a keyboard target or allocate a layer for a very long panel.
    const owner = photoOwners.get(element) || element;
    if (owner.contains(document.activeElement) || !element.getClientRects().length || element.getBoundingClientRect().height > 900) return;
    for (const [animation, target] of active) {
      if (target === element) { animation.cancel(); active.delete(animation); }
    }
    try {
      const animation = element.animate(frames, options);
      active.set(animation, element);
      Promise.resolve(animation.finished).then(() => active.delete(animation), () => active.delete(animation));
    } catch (_) {}
  }
  function cancel(root) {
    for (const [animation, element] of active) {
      if (!root || root === element || root.contains(element)) {
        animation.cancel();
        active.delete(animation);
      }
    }
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting || !allowed()) continue;
      const element = entry.target;
      if (!observed.has(element)) continue;
      observer.unobserve(element);
      observed.delete(element);
      if (seen.has(element) || !element.isConnected || !ownsEntrance(element)) continue;
      seen.add(element);
      if (element.matches(photoReveal)) {
        const images = collect(element, 'img');
        if (element.tagName === 'IMG' || images.length !== 1 ||
            element.closest('.at-hero-banner, .at-hero, [data-mnl-lcp]')) continue;
        const image = images[0];
        if (seenPhotos.has(image)) continue;
        seenPhotos.add(image);
        if (!image.complete || image.naturalWidth <= 0 ||
            (image.getAttribute('fetchpriority') || '').toLowerCase() === 'high') continue;
        photoOwners.set(image, element);
        play(image, [{ transform: 'scale(1.035)' }, { transform: 'scale(1)' }],
          { duration: 620, easing: 'cubic-bezier(.16,1,.3,1)' });
        continue;
      }
      const siblings = element.parentElement ? Array.from(element.parentElement.children) : [element];
      const index = Math.max(0, siblings.indexOf(element));
      play(element, [
        { opacity: 0.78, transform: 'translateY(8px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 320, delay: Math.min(index, 3) * 35, easing: 'cubic-bezier(.16,1,.3,1)' });
    }
  }, { threshold: 0.12, rootMargin: '0px 0px -3% 0px' }) : null;
  function collect(root, query) {
    if (!root || !root.querySelectorAll) return [];
    const result = Array.from(root.querySelectorAll(query));
    if (root.matches && root.matches(query)) result.unshift(root);
    return result;
  }
  function scan(root) {
    for (const details of collect(root, disclosures)) {
      if (!openStates.has(details)) openStates.set(details, details.open);
    }
    for (const image of collect(root, photos)) {
      if (!photoSources.has(image)) photoSources.set(image, image.currentSrc || image.src || '');
    }
    if (!observer || !allowed()) return;
    for (const element of collect(root, selector)) {
      if (seen.has(element) || observed.has(element) || !ownsEntrance(element)) continue;
      observed.add(element);
      observer.observe(element);
    }
  }
  function disconnect() {
    if (observer) observer.disconnect();
    observed.clear();
  }
  function photoLoaded(event) {
    const image = event.target;
    if (!image || !image.matches || !image.matches(photos) || !image.complete || image.naturalWidth <= 0) return;
    const source = image.currentSrc || image.src || '';
    const previous = photoSources.get(image);
    photoSources.set(image, source);
    if (previous === undefined || previous === source || !source || !image.getClientRects().length) return;
    play(image, [{ opacity: 0.7 }, { opacity: 1 }], { duration: 180, easing: 'ease-out' });
  }
  function preferenceChanged() {
    if (reduced.matches) { cancel(); disconnect(); }
    else scan(document);
  }
  function disclosureToggled(event) {
    const details = event.target;
    if (!details || !openStates.has(details)) return;
    const previous = openStates.get(details);
    openStates.set(details, details.open);
    if (previous === details.open) return;
    const content = Array.from(details.children).find(child => child.matches(disclosureContent));
    if (!content) return;
    cancel(content);
    // Closing stays native and immediate. No height measurement loop or click interception.
    if (details.open) play(content, [{ opacity: 0.78 }, { opacity: 1 }], { duration: 160, easing: 'ease-out' });
  }
  if (reduced.addEventListener) reduced.addEventListener('change', preferenceChanged);
  else if (reduced.addListener) reduced.addListener(preferenceChanged);
  document.addEventListener('load', photoLoaded, true);
  document.addEventListener('toggle', disclosureToggled, true);
  document.addEventListener('focusin', event => {
    for (const [animation, element] of active) {
      const owner = photoOwners.get(element) || element;
      if (owner.contains(event.target)) { animation.cancel(); active.delete(animation); }
    }
  });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    cancel(event.target);
    for (const element of observed) {
      if (event.target === element || event.target.contains(element)) {
        if (observer) observer.unobserve(element);
        observed.delete(element);
      }
    }
    for (const image of collect(event.target, photos)) photoSources.delete(image);
    for (const details of collect(event.target, disclosures)) openStates.delete(details);
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { cancel(); disconnect(); }
    else scan(document);
  });
  window.addEventListener('pagehide', () => { suspended = true; cancel(); disconnect(); });
  window.addEventListener('pageshow', () => { suspended = false; scan(document); });
  window.MNLAtelierKinetics = { version: '1484', scan };
  document.body.dataset.atKinetics = '1484';
  scan(document);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-brand-ribbon"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mnl-brand-ribbon')){
  customElements.define('mnl-brand-ribbon',class extends HTMLElement{
    connectedCallback(){
      this._cleanup();
      this._events=new AbortController();
      const signal=this._events.signal;
      this._button=this.querySelector('.mnl-brand-ribbon__toggle');
      this._viewport=this.querySelector('.mnl-brand-ribbon__viewport');
      this._group=this.querySelector('.mnl-brand-ribbon__group');
      if(!this._button||!this._viewport||!this._group)return;
      this._motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this._userPaused??=false;
      this._visible=!('IntersectionObserver' in window);
      this._button.addEventListener('click',()=>{this._userPaused=!this._userPaused;this._sync();},{signal});
      this._motion.addEventListener('change',()=>this._sync(),{signal});
      document.addEventListener('visibilitychange',()=>this._sync(),{signal});
      if('IntersectionObserver' in window){
        this._intersection=new IntersectionObserver(entries=>{
          this._visible=entries.some(entry=>entry.isIntersecting);
          this._sync();
        });
        this._intersection.observe(this);
      }
      this._sync();
      if('ResizeObserver' in window){
        this._resize=new ResizeObserver(()=>this._measure());
        this._resize.observe(this._viewport);
        this._resize.observe(this._group);
      }else{
        window.addEventListener('resize',()=>this._measure(),{signal});
      }
    }
    _measure(){
      if(!this.hasAttribute('data-motion'))return;
      const width=this._viewport.getBoundingClientRect().width;
      const value=width+'px';
      if(this.style.getPropertyValue('--mnl-ribbon-width')!==value)this.style.setProperty('--mnl-ribbon-width',value);
      const duration=Math.max(20,this._group.getBoundingClientRect().width/24)+'s';
      if(this.style.getPropertyValue('--mnl-ribbon-duration')!==duration)this.style.setProperty('--mnl-ribbon-duration',duration);
    }
    _sync(){
      if(!this.isConnected||this._events?.signal.aborted||!this._motion)return;
      const enabled=this.dataset.enabled!=='false'&&!this._motion.matches;
      this.toggleAttribute('data-motion',enabled);
      this._button.hidden=!enabled;
      this.dataset.userPaused=String(this._userPaused);
      this.dataset.playing=String(enabled&&!this._userPaused&&this._visible&&!document.hidden);
      const label=this._userPaused?this._button.dataset.playLabel:this._button.dataset.pauseLabel;
      this._button.setAttribute('aria-label',label);
      this._button.title=label;
      this._measure();
    }
    _cleanup(){
      this._events?.abort();
      this._intersection?.disconnect();
      this._resize?.disconnect();
    }
    disconnectedCallback(){
      this._cleanup();
      this.dataset.playing='false';
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-campaign-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mnl-campaign-carousel')) {
    customElements.define('mnl-campaign-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.slides = Array.from(this.querySelectorAll('[data-campaign-slide]'));
        if (this.slides.length < 2) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.controls = this.querySelector('[data-campaign-controls]');
        this.dots = Array.from(this.querySelectorAll('[data-campaign-dot]'));
        this.toggle = this.querySelector('[data-campaign-toggle]');
        this.status = this.querySelector('[data-campaign-status]');
        this.stage = this.querySelector('[data-campaign-stage]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = Number.isInteger(this.index) ? this.normalizeIndex(this.index) : 0;
        this.loading = false;
        this.userPaused = this.userPaused || this.motion.matches;
        this.hovered = false;
        this.focused = this.contains(document.activeElement);
        this.inView = false;
        this.requestVersion = (this.requestVersion || 0) + 1;
        this.settleSlides();
        this.controls.hidden = false;
        this.setAttribute('data-enhanced', '');
        this.querySelector('[data-campaign-previous]').addEventListener('click', () => this.goTo(this.index - 1, true), { signal });
        this.querySelector('[data-campaign-next]').addEventListener('click', () => this.goTo(this.index + 1, true), { signal });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index, true), { signal }));
        this.toggle.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.syncPlayback();
        }, { signal });
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'touch') return;
          this.hovered = true;
          this.syncPlayback();
        }, { signal });
        this.addEventListener('pointerleave', event => {
          if (event.pointerType === 'touch') return;
          this.hovered = false;
          this.syncPlayback();
        }, { signal });
        this.addEventListener('focusin', () => {
          this.focused = true;
          this.syncPlayback();
        }, { signal });
        this.addEventListener('focusout', event => {
          this.focused = this.contains(event.relatedTarget);
          this.syncPlayback();
        }, { signal });
        this.controls.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          const dotIndex = this.dots.indexOf(event.target);
          if (dotIndex < 0) return;
          const destinations = { ArrowLeft: dotIndex - 1, ArrowRight: dotIndex + 1, Home: 0, End: this.slides.length - 1 };
          if (!(event.key in destinations)) return;
          event.preventDefault();
          const next = this.normalizeIndex(destinations[event.key]);
          this.dots[next].focus({ preventScroll: true });
          this.goTo(next, true);
        }, { signal });
        this.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'touch' || event.target.closest('[data-campaign-toggle]')) return;
          this.userPaused = true;
          this.syncPlayback();
        }, { passive: true, signal });
        this.stage.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'touch' || !event.isPrimary || event.target.closest('a, button')) return;
          this.touchStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
        }, { passive: true, signal });
        this.stage.addEventListener('pointerup', event => {
          const start = this.touchStart;
          this.touchStart = null;
          if (!start || start.id !== event.pointerId) return;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          this.goTo(this.index + (dx < 0 ? 1 : -1), true);
        }, { passive: true, signal });
        this.stage.addEventListener('pointercancel', () => { this.touchStart = null; }, { passive: true, signal });
        document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) {
            this.userPaused = true;
            this.settleSlides();
          }
          this.syncPlayback();
        }, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.25);
            this.syncPlayback();
          }, { threshold: [0, 0.25] });
          this.observer.observe(this.stage);
        }
        this.syncPlayback();
      }

      disconnectedCallback() {
        this.requestVersion = (this.requestVersion || 0) + 1;
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.observer = null;
        clearTimeout(this.autoplayTimer);
        clearTimeout(this.transitionTimer);
        cancelAnimationFrame(this.transitionFrame);
        this.touchStart = null;
        this.loading = false;
        this.removeAttribute('data-running');
      }

      normalizeIndex(index) {
        return (index + this.slides.length) % this.slides.length;
      }

      canPlay() {
        return this.isConnected && !this.userPaused && !this.motion.matches && !this.hovered && !this.focused && !document.hidden && this.inView;
      }

      syncPlayback() {
        clearTimeout(this.autoplayTimer);
        const paused = this.userPaused || this.motion.matches;
        const running = this.canPlay();
        this.setAttribute('data-running', String(running));
        this.toggle.disabled = this.motion.matches;
        this.toggle.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.querySelector('[data-campaign-pause-icon]').toggleAttribute('hidden', paused);
        this.querySelector('[data-campaign-play-icon]').toggleAttribute('hidden', !paused);
        if (running && !this.loading) this.autoplayTimer = setTimeout(() => this.goTo(this.index + 1), 7000);
      }

      settleSlides() {
        clearTimeout(this.transitionTimer);
        cancelAnimationFrame(this.transitionFrame);
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.hidden = !active;
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
          slide.classList.toggle('is-active', active);
        });
      }

      loadSlide(slide) {
        const image = slide.querySelector('img');
        if (!image.dataset.src && image.complete) return Promise.resolve(image.naturalWidth > 0);
        return new Promise(resolve => {
          const signal = this.controller.signal;
          let timeout;
          const finish = result => {
            clearTimeout(timeout);
            image.removeEventListener('load', loaded);
            image.removeEventListener('error', failed);
            signal.removeEventListener('abort', failed);
            resolve(result);
          };
          const loaded = () => finish(true);
          const failed = () => finish(false);
          image.addEventListener('load', loaded, { once: true });
          image.addEventListener('error', failed, { once: true });
          signal.addEventListener('abort', failed, { once: true });
          timeout = setTimeout(failed, 12000);
          image.loading = 'eager';
          slide.querySelectorAll('source[data-srcset]').forEach(source => {
            source.srcset = source.dataset.srcset;
            delete source.dataset.srcset;
          });
          if (image.dataset.src) {
            image.src = image.dataset.src;
            delete image.dataset.src;
          }
          if (image.complete && image.naturalWidth > 0) finish(true);
        });
      }

      async goTo(index, manual = false) {
        if (!this.controller) return;
        if (manual) this.userPaused = true;
        const next = this.normalizeIndex(index);
        const version = ++this.requestVersion;
        this.loading = next !== this.index;
        this.syncPlayback();
        if (next === this.index) return;
        const loaded = await this.loadSlide(this.slides[next]);
        if (!this.isConnected || version !== this.requestVersion || !this.controller) return;
        this.loading = false;
        if (!loaded || (!manual && !this.canPlay())) {
          this.syncPlayback();
          return;
        }
        this.settleSlides();
        const previous = this.slides[this.index];
        const incoming = this.slides[next];
        this.index = next;
        previous.inert = true;
        previous.setAttribute('aria-hidden', 'true');
        incoming.hidden = false;
        incoming.inert = false;
        incoming.setAttribute('aria-hidden', 'false');
        this.dots.forEach((dot, dotIndex) => {
          if (dotIndex === next) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.status.setAttribute('aria-live', manual ? 'polite' : 'off');
        this.status.textContent = `${next + 1} / ${this.slides.length}`;
        if (this.motion.matches) {
          this.settleSlides();
        } else {
          this.transitionFrame = requestAnimationFrame(() => {
            this.transitionFrame = requestAnimationFrame(() => {
              incoming.classList.add('is-active');
              previous.classList.remove('is-active');
              this.transitionTimer = setTimeout(() => this.settleSlides(), 520);
            });
          });
        }
        this.syncPlayback();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-cart-feedback"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mnl-cart-feedback')){
  let activeFeedback=null;
  const storageKey='mnl-cart-feedback-v1';
  const ttl=30000;
  customElements.define('mnl-cart-feedback',class extends HTMLElement{
    static receipt(value,now=Date.now()){
      if(!value||value.v!==1||!['preworkout','single-active'].includes(value.source)||!Number.isFinite(value.at)||value.at>now||now-value.at>=ttl||!Array.isArray(value.items)||!value.items.length||value.items.length>10)return null;
      const items=[];
      for(const item of value.items){
        const variantId=String(item?.variantId||'');
        const key=item?.key;
        if(!/^[1-9]\d*$/.test(variantId)||typeof key!=='string'||!new RegExp('^'+variantId+':[a-zA-Z0-9_-]{1,128}$').test(key))return null;
        if(!items.some(existing=>existing.key===key))items.push({key,variantId});
      }
      return {v:1,at:value.at,source:value.source,items,message:typeof value.message==='string'?value.message.slice(0,180):''};
    }
    connectedCallback(){
      if(activeFeedback&&activeFeedback!==this&&activeFeedback.isConnected)return;
      this._cleanup();
      activeFeedback=this;
      this._events=new AbortController();
      this._effects=new Map();
      this._activeRows=new Map();
      this._roots=new Set();
      this._status=this.querySelector('.mnl-cart-feedback__status');
      const signal=this._events.signal;
      document.addEventListener('mnl:cart:add-confirmed',event=>this._confirm(event.detail),{signal});
      for(const name of ['mnl:cart:opened','mnl:cart:updated','shopify:section:load'])document.addEventListener(name,()=>{this._watch();this._schedule();},{signal});
      this._watch();
      try{this._pending=this.constructor.receipt(JSON.parse(sessionStorage.getItem(storageKey)));}catch{this._pending=null;}
      if(this._pending){this._restored=true;this._armExpiry();this._schedule();}
      else this._removeStored();
    }
    _confirm(detail){
      const receipt=this.constructor.receipt({v:1,at:Date.now(),source:detail?.source,items:detail?.items,message:detail?.message});
      if(!receipt)return;
      this._pending=receipt;
      this._restored=false;
      this._store();
      this._armExpiry();
      if(detail.announce!==false)this._announce(receipt.message);
      if(Array.isArray(detail.buttons))detail.buttons.forEach(button=>this._check(button));
      this._watch();
      this._schedule();
    }
    _announce(message){if(this._status)this._status.textContent=message;}
    _check(button){
      if(!(button instanceof HTMLElement)||button.tagName!=='BUTTON'||!button.isConnected)return;
      this._finishEffect(button);
      const check=document.createElement('span');
      check.className='mnl-cart-feedback__check';
      check.textContent='✓';
      check.setAttribute('aria-hidden','true');
      button.classList.add('mnl-cart-feedback-button');
      button.appendChild(check);
      const clear=()=>{check.remove();button.classList.remove('mnl-cart-feedback-button');};
      this._effects.set(button,{clear,timer:setTimeout(()=>this._finishEffect(button),1400)});
    }
    _watch(){
      if(!('MutationObserver' in window))return;
      this._observer??=new MutationObserver(()=>this._schedule());
      for(const root of document.querySelectorAll('#mnl-hd-cart-body,.mnl-cart__items')){
        if(this._roots.has(root))continue;
        this._roots.add(root);
        this._observer.observe(root,{childList:true,subtree:true});
      }
    }
    _schedule(){
      if(this._scheduled||(!this._pending&&!this._activeRows.size))return;
      this._scheduled=true;
      const signal=this._events.signal;
      queueMicrotask(()=>{this._scheduled=false;if(!signal.aborted&&this.isConnected)this._mark();});
    }
    _mark(){
      const rows=[...document.querySelectorAll('#mnl-hd-cart-body .mnl-hd-cart__item[data-cart-key],.mnl-cart__items .mnl-cart__item[data-key]')];
      const findRow=key=>rows.find(node=>(node.getAttribute('data-cart-key')||node.getAttribute('data-key'))===key&&node.getClientRects().length&&!node.closest('[aria-hidden="true"],[inert]'));
      for(const [key,until] of this._activeRows){
        if(until<=Date.now()){this._activeRows.delete(key);continue;}
        const row=findRow(key);
        if(row&&!this._effects.has(row))this._highlight(row,key,until,true);
      }
      const receipt=this.constructor.receipt(this._pending);
      if(!receipt){this._pending=null;this._removeStored();return;}
      const remaining=[];
      let marked=false;
      for(const item of receipt.items){
        const row=findRow(item.key);
        if(!row){remaining.push(item);continue;}
        this._highlight(row,item.key,Date.now()+1800,false);
        marked=true;
      }
      if(marked&&this._restored){this._announce(receipt.message);this._restored=false;}
      this._pending=remaining.length?{...receipt,items:remaining}:null;
      if(this._pending)this._store();
      else{clearTimeout(this._expiry);this._removeStored();}
    }
    _highlight(row,key,until,restored){
      this._finishEffect(row);
      this._activeRows.set(key,until);
      row.classList.add('mnl-cart-feedback-row');
      if(restored)row.classList.add('mnl-cart-feedback-row--restored');
      this._effects.set(row,{clear:()=>row.classList.remove('mnl-cart-feedback-row','mnl-cart-feedback-row--restored'),timer:setTimeout(()=>{this._finishEffect(row);if(this._activeRows.get(key)===until)this._activeRows.delete(key);},Math.max(0,until-Date.now()))});
    }
    _armExpiry(){
      clearTimeout(this._expiry);
      this._expiry=setTimeout(()=>{this._pending=null;this._removeStored();},Math.max(0,ttl-(Date.now()-this._pending.at)));
    }
    _store(){try{sessionStorage.setItem(storageKey,JSON.stringify(this._pending));}catch{}}
    _removeStored(){try{sessionStorage.removeItem(storageKey);}catch{}}
    _finishEffect(node){const effect=this._effects?.get(node);if(!effect)return;clearTimeout(effect.timer);effect.clear();this._effects.delete(node);}
    _cleanup(){
      this._events?.abort();
      this._observer?.disconnect();
      this._observer=null;
      clearTimeout(this._expiry);
      for(const node of this._effects?.keys()||[])this._finishEffect(node);
      this._activeRows?.clear();
      this._scheduled=false;
    }
    disconnectedCallback(){this._cleanup();if(activeFeedback===this)activeFeedback=null;}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-configurator-adjustment"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mnl-configurator-adjustment')) {
  customElements.define('mnl-configurator-adjustment', class extends HTMLElement {
    connectedCallback() {
      if (this.abort && !this.abort.signal.aborted) { this.mount(); return; }
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      ['DOMContentLoaded','mnl:config-engine-ready','mnl:recipe-catalog-ready','shopify:section:load'].forEach(name => document.addEventListener(name,() => this.mount(),options));
      window.addEventListener('mnl:config-engine-ready',() => this.mount(),options);
      window.addEventListener('pagehide',() => this.invalidate(),options);
      window.addEventListener('blur',() => this.invalidate(),options);
      document.addEventListener('visibilitychange',() => { if (document.hidden) this.invalidate(); },options);
      this.mount();
    }
    disconnectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) return;
        this.invalidate();
        this.abort?.abort();
        this.overlayAbort?.abort();
        this.observer?.disconnect();
        this.sourcesObserver?.disconnect();
        this.overlay = null;
      });
    }
    api() {
      const api = window.MNL_CONFIG_ADJUSTMENT;
      return api && typeof api.capture === 'function' && typeof api.inspect === 'function' && typeof api.restore === 'function' ? api : null;
    }
    inspect(api) {
      try {
        const value = api?.inspect();
        return value && typeof value.fingerprint === 'string' ? value : null;
      } catch (_) { return null; }
    }
    release(snapshot,api) {
      if (!snapshot) return;
      try { api?.release?.(snapshot.token); } catch (_) {}
    }
    mount() {
      const overlay = document.getElementById('mnl-overlay');
      if (!overlay || this.overlay === overlay) return;
      this.invalidate();
      this.overlayAbort?.abort();
      this.observer?.disconnect();
      this.sourcesObserver?.disconnect();
      this.overlay = overlay;
      this.overlayAbort = new AbortController();
      const options = {capture:true,signal:this.overlayAbort.signal};
      overlay.addEventListener('pointerdown',event => this.onPointer(event),options);
      overlay.addEventListener('focusin',event => this.onFocus(event),options);
      overlay.addEventListener('keydown',event => this.onKeyDown(event),options);
      overlay.addEventListener('keyup',event => this.onKeyUp(event),options);
      overlay.addEventListener('input',event => this.onInput(event),options);
      overlay.addEventListener('change',event => this.onChange(event),options);
      overlay.addEventListener('focusout',event => { if (event.target === this.pending?.control) this.finish(); },options);
      document.addEventListener('click',event => this.onClick(event),options);
      window.addEventListener('click',event => this.closeButton(event),{signal:this.overlayAbort.signal});
      window.addEventListener('pointerup',event => {
        if (this.pending?.kind === 'pointer' && event.pointerId === this.pending.pointerId) this.finish();
      },options);
      window.addEventListener('pointercancel',event => {
        if (this.pending?.kind === 'pointer' && event.pointerId === this.pending.pointerId) this.invalidate();
      },options);
      this.contextKey = this.context();
      this.observer = new MutationObserver(() => {
        const context = this.context();
        if (context !== this.contextKey) { this.contextKey = context; this.invalidate(); }
      });
      this.observer.observe(overlay,{attributes:true,attributeFilter:['class']});
      const config = document.getElementById('mnl-configurator');
      if (config) this.observer.observe(config,{attributes:true,attributeFilter:['data-config-mode']});
      overlay.querySelectorAll('.mnl-step[data-step]').forEach(panel => this.observer.observe(panel,{attributes:true,attributeFilter:['class']}));
      this.sourcesObserver = new MutationObserver(() => queueMicrotask(() => this.guard()));
      ['mnl-price-val','mnl-billing-once-price','mnl-side-r-actifs-list','mnl-doses-count','mnl-side-r-flavor'].map(id => document.getElementById(id)).filter(Boolean).forEach(node => this.sourcesObserver.observe(node,{childList:true,subtree:true,characterData:true}));
    }
    context() {
      const overlay = this.overlay;
      return JSON.stringify([!!overlay?.isConnected,!!overlay?.classList.contains('is-open'),document.getElementById('mnl-configurator')?.getAttribute('data-config-mode'),overlay?.querySelector('.mnl-step.is-active')?.dataset.step]);
    }
    eligible(control) {
      return !!(control?.matches?.('input[type="range"].mnl-obj__slider[data-obj],input[type="range"][data-act-slider],input[type="range"][data-slider]') &&
        this.overlay?.isConnected && this.overlay.contains(control) && this.overlay.classList.contains('is-open') &&
        !control.disabled && control.getAttribute('aria-disabled') !== 'true' && !control.closest('[hidden],[inert],[aria-hidden="true"]') &&
        control.closest('.mnl-step.is-active')?.dataset.step === '2' && !document.hidden);
    }
    begin(control,kind,pointerId) {
      if (!this.eligible(control)) return false;
      if (this.pending?.control === control) {
        clearTimeout(this.keyTimer);
        if (this.commitFrame) cancelAnimationFrame(this.commitFrame);
        this.commitFrame = 0;
        if (kind !== 'focus') this.pending.kind = kind;
        if (kind === 'pointer') this.pending.pointerId = pointerId;
        return true;
      }
      this.invalidate();
      const api = this.api();
      let before;
      try { before = api?.capture(); } catch (_) {}
      if (!before || before.token == null || typeof before.fingerprint !== 'string') return false;
      this.pending = {control,kind,pointerId,api,before,context:this.context(),dirty:false,expected:null};
      return true;
    }
    onPointer(event) {
      if (!event.isTrusted || event.isPrimary === false || (event.button != null && event.button !== 0)) return;
      if (this.eligible(event.target)) {
        if (this.begin(event.target,'pointer',event.pointerId) && event.target.id === 'mnl-doses-slider') this.settle(this.pending);
      }
      else if (!event.target.closest?.('[data-adjustment-feedback]')) this.invalidate();
    }
    onFocus(event) {
      if (!this.restoringFocus && event.isTrusted && this.eligible(event.target)) this.begin(event.target,'focus');
    }
    onKeyDown(event) {
      if (!event.isTrusted || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','PageUp','PageDown','Home','End'].includes(event.key)) return;
      if (this.eligible(event.target)) this.begin(event.target,'keyboard');
    }
    onKeyUp(event) {
      if (!event.isTrusted || this.pending?.control !== event.target || this.pending.kind !== 'keyboard') return;
      if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','PageUp','PageDown','Home','End'].includes(event.key)) return;
      clearTimeout(this.keyTimer);
      this.keyTimer = setTimeout(() => this.finish(),450);
    }
    onInput(event) {
      const fromButton = this.pending?.kind === 'button' && this.pending.allowSynthetic && this.pending.control === event.target;
      if ((!event.isTrusted && !fromButton) || !this.eligible(event.target)) { this.invalidate(); return; }
      const pending = this.pending;
      if (!pending || pending.control !== event.target) return;
      if (pending.kind === 'focus') pending.kind = 'input';
      pending.dirty = true;
      this.settle(pending);
      if (pending.kind === 'input') this.finish();
    }
    settle(pending) {
      pending.checking = true;
      if (this.inspectFrame) cancelAnimationFrame(this.inspectFrame);
      this.inspectFrame = requestAnimationFrame(() => {
        this.inspectFrame = 0;
        if (this.pending !== pending) return;
        const value = this.inspect(pending.api);
        if (!value || pending.context !== this.context()) { this.invalidate(); return; }
        pending.expected = value.fingerprint;
        pending.checking = false;
      });
    }
    onChange(event) {
      const fromButton = this.pending?.kind === 'button' && this.pending.allowSynthetic && this.pending.control === event.target;
      if ((!event.isTrusted && !fromButton) || !this.eligible(event.target)) { this.invalidate(); return; }
      if (this.pending?.control === event.target && this.pending.kind === 'input') this.finish();
    }
    onClick(event) {
      const button = event.target.closest?.('[data-adjustment-undo]');
      if (button && this.feedback?.contains(button)) {
        if (event.isTrusted) this.undo();
        return;
      }
      const quantity = event.target.closest?.('.mnl-easy-quantities button[data-dose-index],.mnl-studio-adjust button[data-dose-adjust]');
      const slider = this.overlay?.querySelector('#mnl-doses-slider');
      if (event.isTrusted && quantity && !quantity.disabled && this.overlay.contains(quantity) && this.eligible(slider)) {
        if (!this.begin(slider,'button')) return;
        const pending = this.pending;
        pending.allowSynthetic = true;
        pending.triggerEvent = event;
        this.buttonTimer = setTimeout(() => this.closeButton(event),0);
        return;
      }
      if (event.target.closest?.('[data-adjustment-feedback]') || this.eligible(event.target)) return;
      const actionable = event.target.closest?.('button,a,summary,label,input,select,[role="button"],[role="radio"]');
      if (actionable && (this.overlay?.contains(actionable) || document.getElementById('mnl-sticky-atc')?.contains(actionable))) this.invalidate();
    }
    closeButton(event) {
      if (this.pending?.triggerEvent !== event) return;
      clearTimeout(this.buttonTimer);
      this.pending.allowSynthetic = false;
      this.finish();
    }
    finish() {
      clearTimeout(this.keyTimer);
      if (!this.pending || this.commitFrame) return;
      this.commitFrame = requestAnimationFrame(() => { this.commitFrame=0; this.commit(); });
    }
    commit() {
      const pending = this.pending;
      if (!pending) return;
      if (pending.checking) { this.finish(); return; }
      const after = this.inspect(pending.api);
      if (!pending.dirty || !this.eligible(pending.control) || pending.context !== this.context() ||
        pending.api !== this.api() || !after || !pending.expected || after.fingerprint !== pending.expected ||
        after.fingerprint === pending.before.fingerprint) { this.invalidate(); return; }
      this.pending = null;
      this.last = {control:pending.control,api:pending.api,before:pending.before,after:after.fingerprint,context:pending.context};
      this.show(pending.control,this.priceMessage(pending.before.price,after.price));
    }
    priceMessage(before,after) {
      if (!before || !after || !Number.isSafeInteger(before.minor) || !Number.isSafeInteger(after.minor) ||
        before.currency !== after.currency || !/^pot:/.test(before.basis || '') || !/^pot:/.test(after.basis || '')) return this.dataset.saved;
      const delta = after.minor - before.minor;
      if (!delta) return this.dataset.priceSame;
      try {
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'fr',{style:'currency',currency:after.currency,signDisplay:'always'}).format(delta/100);
        return this.dataset.priceChange.replace('__amount__',amount);
      } catch (_) { return this.dataset.saved; }
    }
    show(control,text) {
      this.feedback?.remove();
      this.feedback = this.querySelector('template')?.content.firstElementChild?.cloneNode(true);
      if (!this.feedback) { this.invalidate(); return; }
      const fineRow = control.closest('.mnl-obj-act__row,.mnl-ing-row');
      const card = control.closest('.mnl-obj,.mnl-doses-block');
      if (fineRow) fineRow.after(this.feedback);
      else if (card) card.append(this.feedback);
      else control.after(this.feedback);
      this.feedback.querySelector('[data-adjustment-message]').textContent = text;
    }
    guard() {
      if (this.pending) {
        if (!this.pending.checking) {
          const current = this.inspect(this.pending.api);
          const expected = this.pending.expected || this.pending.before.fingerprint;
          if (!current || current.fingerprint !== expected) this.invalidate();
        }
        return;
      }
      if (!this.last) return;
      const current = this.inspect(this.last.api);
      if (!this.eligible(this.last.control) || this.last.context !== this.context() ||
        this.last.api !== this.api() || !current || current.fingerprint !== this.last.after) this.invalidate();
    }
    undo() {
      const last = this.last;
      if (!last) return;
      const current = this.inspect(last.api);
      if (!this.eligible(last.control) || last.context !== this.context() || last.api !== this.api() ||
        !current || current.fingerprint !== last.after) { this.unavailable(); return; }
      let restored = false;
      try { restored = last.api.restore(last.before.token,last.after) === true; } catch (_) {}
      if (!restored) { this.unavailable(); return; }
      this.last = null;
      this.release(last.before,last.api);
      const button = this.feedback?.querySelector('[data-adjustment-undo]');
      if (button) button.hidden = true;
      const message = this.feedback?.querySelector('[data-adjustment-message]');
      if (message) message.textContent = this.dataset.undone;
      if (last.control.isConnected) {
        this.restoringFocus = true;
        try { last.control.focus({preventScroll:true}); } finally { this.restoringFocus = false; }
      }
    }
    unavailable() {
      const last = this.last;
      this.last = null;
      this.release(last?.before,last?.api);
      const button = this.feedback?.querySelector('[data-adjustment-undo]');
      if (button) button.hidden = true;
      const message = this.feedback?.querySelector('[data-adjustment-message]');
      if (message) message.textContent = this.dataset.unavailable;
      if (last?.control && this.eligible(last.control)) {
        this.restoringFocus = true;
        try { last.control.focus({preventScroll:true}); } finally { this.restoringFocus = false; }
      }
    }
    invalidate() {
      clearTimeout(this.keyTimer);
      clearTimeout(this.buttonTimer);
      if (this.commitFrame) cancelAnimationFrame(this.commitFrame);
      if (this.inspectFrame) cancelAnimationFrame(this.inspectFrame);
      this.commitFrame = 0;
      this.inspectFrame = 0;
      this.release(this.pending?.before,this.pending?.api);
      this.release(this.last?.before,this.last?.api);
      this.pending = null;
      this.last = null;
      this.feedback?.remove();
      this.feedback = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-configurator-guidance"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('mnl-configurator-guidance')) return;
  let sequence = 0;
  class MNLConfiguratorGuidance extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.media = window.matchMedia('(max-width:980px)');
      this.described = new Set();
      this.note = document.createElement('p');
      this.note.id = 'mnl-step-guidance-' + String(++sequence);
      this.note.className = 'mnl-step-guidance';
      this.note.hidden = true;
      this.note.setAttribute('role', 'status');
      this.note.setAttribute('aria-live', 'polite');
      this.note.setAttribute('aria-atomic', 'true');
      this.queue = () => {
        if (this.queued) return;
        this.queued = true;
        queueMicrotask(() => {
          this.queued = false;
          if (this.isConnected && this.controller) this.sync();
        });
      };
      const signal = this.controller.signal;
      document.addEventListener('DOMContentLoaded', () => this.bind(), {once:true, signal});
      document.addEventListener('shopify:section:load', () => this.bind(), {signal});
      document.addEventListener('shopify:section:unload', event => {
        if (event.target?.contains(this.overlay)) this.unbind();
      }, {signal});
      this.media.addEventListener('change', this.queue, {signal});
      if (document.readyState !== 'loading') this.bind();
    }
    disconnectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected || !this.controller) return;
        this.unbind();
        this.controller.abort();
        this.controller = null;
      });
    }
    bind() {
      if (!this.isConnected || !this.controller) return;
      const overlay = document.getElementById('mnl-overlay');
      const nav = overlay?.querySelector('#mnl-wizard-nav');
      if (overlay === this.overlay && nav === this.nav && this.observer) {
        this.queue();
        return;
      }
      this.unbind();
      if (!overlay || !nav) return;
      this.overlay = overlay;
      this.nav = nav;
      this.bar = document.getElementById('mnl-sticky-atc');
      this.observer = new MutationObserver(this.queue);
      this.observer.observe(overlay, {attributes:true, attributeFilter:['class']});
      this.observer.observe(nav, {childList:true, subtree:true});
      overlay.querySelectorAll('.mnl-step[data-step]').forEach(step => this.observer.observe(step, {attributes:true, attributeFilter:['class']}));
      if (this.bar) this.observer.observe(this.bar, {attributes:true, attributeFilter:['class','style','hidden'], childList:true});
      this.observer.observe(document.body, {attributes:true, attributeFilter:['class']});
      document.querySelectorAll('.mnl-modal').forEach(modal => this.observer.observe(modal, {attributes:true, attributeFilter:['class','hidden']}));
      this.sync();
    }
    describe(elements) {
      const next = new Set(elements.filter(Boolean));
      this.described.forEach(element => {
        if (next.has(element)) return;
        const tokens = (element.getAttribute('aria-describedby') || '').split(/\s+/).filter(token => token && token !== this.note.id);
        if (tokens.length) element.setAttribute('aria-describedby', tokens.join(' '));
        else element.removeAttribute('aria-describedby');
      });
      next.forEach(element => {
        const tokens = new Set((element.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
        if (!tokens.has(this.note.id)) {
          tokens.add(this.note.id);
          element.setAttribute('aria-describedby', [...tokens].join(' '));
        }
      });
      this.described = next;
    }
    clear() {
      if (!this.note) return;
      this.describe([]);
      this.note.hidden = true;
      if (this.note.textContent) this.note.textContent = '';
    }
    sync() {
      if (!this.overlay?.isConnected || !this.nav?.isConnected) {
        this.unbind();
        return;
      }
      const next = this.overlay.querySelector('#mnl-wiz-next');
      if (next !== this.next) {
        this.next = next;
        if (next) this.observer.observe(next, {attributes:true, attributeFilter:['disabled','aria-disabled','title','hidden','style']});
      }
      const step = Number(this.overlay.querySelector('.mnl-step.is-active')?.dataset.step);
      const blocked = Boolean(next && (next.disabled || next.getAttribute('aria-disabled') === 'true'));
      const mobile = this.media.matches;
      const button = mobile ? this.bar?.querySelector('.mnl-sticky-atc__btn') : next;
      const target = mobile ? this.bar : this.nav;
      const modalOpen = document.body.classList.contains('mnl-recap-open') || Boolean(document.querySelector('.mnl-modal.is-open'));
      if (!blocked || !this.overlay.classList.contains('is-open') || modalOpen || !Number.isInteger(step) || step < 1 || step >= 6 || !button || !target || (mobile && (!this.bar.classList.contains('is-visible') || this.bar.hidden))) {
        this.clear();
        return;
      }
      const message = this.getAttribute('data-message-' + String(step)) || this.dataset.messageDefault;
      if (!message) {
        this.clear();
        return;
      }
      if (this.note.parentElement !== target) target.append(this.note);
      if (this.note.textContent !== message) this.note.textContent = message;
      this.note.hidden = false;
      const selector = ({3:'#mnl-doses-slider',4:'#mnl-flavors',5:'#mnl-name'})[step];
      this.describe([button, selector ? this.overlay.querySelector(selector) : null]);
    }
    unbind() {
      this.observer?.disconnect();
      this.observer = null;
      this.clear();
      this.note?.remove();
      this.overlay = null;
      this.nav = null;
      this.bar = null;
      this.next = null;
    }
  }
  customElements.define('mnl-configurator-guidance', MNLConfiguratorGuidance);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-flavor-explorer"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mnl-flavor-explorer')){
  customElements.define('mnl-flavor-explorer',class extends HTMLElement{
    connectedCallback(){
      this._events?.abort();
      this._events=new AbortController();
      this._buttons=Array.from(this.querySelectorAll('[data-flavor-preview]'));
      this._story=this.querySelector('mnl-flavor-story');
      this._output=this.querySelector('[data-preview-label]');
      const choices=this.querySelector('.mnl-flavor-explorer__choices');
      const fallback=this.querySelector('.mnl-flavor-explorer__fallback');
      if(!choices||!fallback||!this._story||!this._output||this._buttons.length!==5)return;
      choices.hidden=false;
      fallback.hidden=true;
      const options={signal:this._events.signal};
      choices.addEventListener('click',event=>{
        const button=event.target.closest('[data-flavor-preview]');
        if(!this._buttons.includes(button)||button.getAttribute('aria-pressed')==='true')return;
        this.select(button);
      },options);
      this._story.addEventListener('mnl:flavor-story-error',event=>{
        if(event.detail.id!==this._story.getAttribute('data-flavor-selection'))return;
        const shown=this._buttons.find(button=>button.dataset.flavorPreview===event.detail.shown)||null;
        this.updateSelection(shown);
        if(shown)this._story.setAttribute('data-flavor-selection',shown.dataset.flavorPreview);
        else this._story.removeAttribute('data-flavor-selection');
      },options);
    }
    select(button){
      if(!this._buttons.includes(button))return;
      const key=button.dataset.flavorPreview;
      if(!['ice_tea','blue_raspberry','lemon','watermelon','cola'].includes(key))return;
      this.updateSelection(button);
      this._story.setAttribute('data-flavor-selection',key);
    }
    updateSelection(button){
      this._buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      if(button)this.dataset.flavor=button.dataset.flavorPreview;
      else delete this.dataset.flavor;
      this._output.textContent=button?this._output.dataset.previewLabel+' '+button.querySelector('[data-flavor-label]').textContent.trim():'';
    }
    disconnectedCallback(){this._events?.abort();}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-flavor-story"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mnl-flavor-story')) {
  customElements.define('mnl-flavor-story', class extends HTMLElement {
    static get observedAttributes() { return ['data-flavor-selection']; }
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.requestId = (this.requestId || 0) + 1;
      this.paused = this.paused || false;
      this.remaining = this.remaining ?? 2400;
      this.cursor = this.cursor || 0;
      this.frameIndex = this.frameIndex ?? -1;
      this.cache ||= new Map();
      this.effects = new Set();
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplay = this.hasAttribute('data-flavor-autoplay');
      this.inView = !('IntersectionObserver' in window);
      this.frames = Array.from(this.querySelectorAll('[data-flavor-frame]'));
      this.button = this.querySelector('[data-flavor-toggle]');
      try {
        const data = JSON.parse(this.querySelector('[data-flavor-story-data]').textContent);
        const ids = ['ice_tea','blue_raspberry','lemon','watermelon','cola'];
        this.flavors = data.flavors.filter((item, index) => item.id === ids[index] && typeof item.name === 'string' && item.name.length > 0 && /^https:\/\/cdn\.shopify\.com\//.test(item.src) && typeof item.srcset === 'string');
      } catch { this.flavors = []; }
      if (this.frames.length !== 2 || this.flavors.length !== 5) {
        this.connected = false;
        this.abort.abort();
        return;
      }
      const options = {signal:this.abort.signal};
      this.button?.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => {
        if (this.autoplay && this.staticView()) this.showPoster();
        else if (this.motion.matches) this.settleFrames();
        this.sync();
      }, options);
      this.frames.forEach(frame => frame.querySelector('[data-flavor-photo]').addEventListener('error', () => this.failedFrame(frame), options));
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.target === this && entry.isIntersecting && entry.intersectionRatio >= 0.15);
          this.sync();
        }, {threshold:0.15});
        this.observer.observe(this);
      }
      if (!this.autoplay && this.getAttribute('data-flavor-selection')) this.select(this.getAttribute('data-flavor-selection'));
      this.sync();
    }
    attributeChangedCallback(name, previous, value) {
      if (name !== 'data-flavor-selection' || previous === value || !this.connected || !this.flavors?.length) return;
      if (value === null || value === '') this.showPoster();
      else this.select(value);
    }
    staticView() { return this.motion.matches || typeof this.frames[0]?.animate !== 'function'; }
    canRun() { return this.connected && this.inView && !document.hidden && !this.motion.matches && !this.paused; }
    sync() {
      if (!this.connected || !this.flavors?.length) return;
      if (this.button) {
        this.button.hidden = !this.autoplay || this.staticView() || !this.activeKey;
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.button.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      }
      if (this.autoplay && this.staticView()) { this.showPoster(); return; }
      if (this.paused) this.settleFrames();
      const running = this.canRun();
      this.effects.forEach(effect => running ? effect.play() : effect.pause());
      if (!this.autoplay) return;
      if (!running) { this.pauseTimer(); return; }
      if (this.deferredKey) {
        const key = this.deferredKey;
        this.deferredKey = null;
        void this.select(key);
        return;
      }
      if (!this.activeKey && !this.pendingKey && !this.hasAttribute('data-flavor-failed')) this.select(this.flavors[this.cursor].id);
      else this.scheduleNext();
    }
    preload(flavor) {
      if (this.cache.has(flavor.id)) return this.cache.get(flavor.id);
      const promise = new Promise((resolve, reject) => {
        const image = new Image();
        let settled = false;
        const fail = () => { if (!settled) { settled = true; image.onload = image.onerror = null; reject(new Error('flavor-image')); } };
        const loaded = async () => {
          if (settled) return;
          try {
            if (!image.naturalWidth) { fail(); return; }
            if (typeof image.decode === 'function') await image.decode();
            if (settled) return;
            settled = true;
            image.onload = image.onerror = null;
            resolve(image);
          } catch { fail(); }
        };
        image.onload = loaded;
        image.onerror = fail;
        image.decoding = 'async';
        image.sizes = this.frames[0].querySelector('[data-flavor-photo]').sizes;
        image.srcset = flavor.srcset;
        image.src = flavor.src;
        if (image.complete && image.naturalWidth) void loaded();
      });
      this.cache.set(flavor.id, promise);
      promise.catch(() => { if (this.cache.get(flavor.id) === promise) this.cache.delete(flavor.id); });
      return promise;
    }
    async select(key) {
      const flavor = this.flavors.find(item => item.id === key);
      if (!this.connected || !flavor || (this.autoplay && this.staticView())) return;
      if (this.activeKey === key && !this.pendingKey) { this.scheduleNext(); return; }
      const request = ++this.requestId;
      this.deferredKey = null;
      this.removeAttribute('data-flavor-deferred');
      this.pendingKey = key;
      this.cursor = this.flavors.indexOf(flavor);
      this.pauseTimer();
      this.settleFrames();
      this.setAttribute('data-flavor-pending', key);
      try {
        await this.preload(flavor);
        if (!this.connected || request !== this.requestId) return;
        const index = this.frameIndex === 0 ? 1 : 0;
        const target = this.frames[index];
        const image = target.querySelector('[data-flavor-photo]');
        delete target.dataset.flavor;
        image.loading = 'eager';
        image.srcset = flavor.srcset;
        image.src = flavor.src;
        if (typeof image.decode === 'function') await image.decode();
        if (!this.connected || request !== this.requestId) return;
        if (this.autoplay && !this.canRun()) {
          this.deferredKey = key;
          this.setAttribute('data-flavor-deferred', key);
          this.sync();
          return;
        }
        target.dataset.flavor = key;
        target.querySelector('[data-flavor-name]').textContent = flavor.name;
        target.hidden = false;
        this.frameIndex = index;
        this.activeKey = key;
        this.pendingKey = null;
        this.deferredKey = null;
        this.remaining = 2400;
        this.removeAttribute('data-flavor-pending');
        this.removeAttribute('data-flavor-deferred');
        this.removeAttribute('data-flavor-failed');
        this.setAttribute('data-flavor-ready', key);
        this.frames.forEach((frame, frameIndex) => { frame.hidden = frameIndex !== index; });
        if (!this.staticView() && this.canRun()) this.enter(target, this.flavors.indexOf(flavor));
        this.dispatchEvent(new CustomEvent('mnl:flavor-story-ready', {bubbles:true, detail:{id:key}}));
        this.sync();
      } catch {
        if (!this.connected || request !== this.requestId) return;
        this.pendingKey = null;
        this.deferredKey = null;
        this.remaining = 2400;
        this.removeAttribute('data-flavor-pending');
        this.removeAttribute('data-flavor-deferred');
        this.setAttribute('data-flavor-failed', key);
        this.dispatchEvent(new CustomEvent('mnl:flavor-story-error', {bubbles:true, detail:{id:key, shown:this.activeKey || null}}));
        this.sync();
      }
    }
    enter(frame, index) {
      const photo = frame.querySelector('[data-flavor-photo]');
      const name = frame.querySelector('[data-flavor-name]');
      const direction = index % 2 ? -1 : 1;
      try {
        const entries = [
          photo.animate([{opacity:0,transform:'translateX(' + (direction * 24) + 'px) scale(.975)'},{opacity:1,transform:'translateX(0) scale(1)'}], {duration:380,easing:'cubic-bezier(.2,.8,.2,1)',fill:'both'}),
          name.animate([{opacity:0,transform:'translateY(10px)'},{opacity:1,transform:'translateY(0)'}], {duration:280,delay:100,easing:'cubic-bezier(.2,.8,.2,1)',fill:'both'})
        ];
        entries.forEach(effect => {
          this.effects.add(effect);
          effect.pause();
          effect.onfinish = () => { effect.onfinish = null; effect.cancel(); this.effects.delete(effect); };
        });
      } catch { this.settleFrames(); }
    }
    settleFrames() {
      this.effects?.forEach(effect => { effect.onfinish = null; effect.cancel(); });
      this.effects?.clear();
      this.frames?.forEach((frame, index) => { frame.hidden = index !== this.frameIndex; });
    }
    failedFrame(frame) {
      if (!this.connected || this.frames[this.frameIndex] !== frame) return;
      const key = this.activeKey;
      delete frame.dataset.flavor;
      const other = this.frames.find(item => item !== frame && item.dataset.flavor && item.querySelector('[data-flavor-photo]').naturalWidth);
      this.settleFrames();
      if (other) {
        this.frameIndex = this.frames.indexOf(other);
        this.activeKey = other.dataset.flavor;
        this.setAttribute('data-flavor-ready', this.activeKey);
        this.settleFrames();
      } else {
        this.frameIndex = -1;
        this.activeKey = null;
        this.frames.forEach(item => { item.hidden = true; });
        this.removeAttribute('data-flavor-ready');
        if (this.button) this.button.hidden = true;
      }
      this.setAttribute('data-flavor-failed', key || 'image');
      this.dispatchEvent(new CustomEvent('mnl:flavor-story-error', {bubbles:true,detail:{id:key,shown:this.activeKey || null}}));
      this.sync();
    }
    scheduleNext() {
      if (!this.autoplay || !this.canRun() || this.staticView() || (!this.activeKey && !this.hasAttribute('data-flavor-failed')) || this.pendingKey || this.timer) return;
      this.startedAt = performance.now();
      this.timer = setTimeout(() => {
        this.timer = null;
        this.remaining = 2400;
        void this.select(this.flavors[(this.cursor + 1) % this.flavors.length].id);
      }, this.remaining);
    }
    pauseTimer() {
      if (!this.timer) return;
      clearTimeout(this.timer);
      this.timer = null;
      this.remaining = Math.max(0, this.remaining - (performance.now() - this.startedAt));
    }
    showPoster() {
      ++this.requestId;
      this.pauseTimer();
      this.settleFrames();
      this.frameIndex = -1;
      this.activeKey = null;
      this.pendingKey = null;
      this.deferredKey = null;
      this.remaining = 2400;
      this.frames?.forEach(frame => { frame.hidden = true; });
      this.removeAttribute('data-flavor-ready');
      this.removeAttribute('data-flavor-pending');
      this.removeAttribute('data-flavor-deferred');
      if (this.button) this.button.hidden = true;
    }
    disconnectedCallback() {
      this.connected = false;
      ++this.requestId;
      this.deferredKey = this.pendingKey || this.deferredKey || null;
      this.pendingKey = null;
      this.pauseTimer();
      this.settleFrames();
      this.abort?.abort();
      this.observer?.disconnect();
      this.observer = null;
      if (this.button) this.button.hidden = true;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-header-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mnl-catalog-navigation')) {
  customElements.define('mnl-catalog-navigation', class extends HTMLElement {
    connectedCallback() {
      this.catalogAbort?.abort();
      this.catalogAbort = new AbortController();
      const options = { signal: this.catalogAbort.signal };
      const details = this.querySelector('details');
      if (details) {
        document.addEventListener('pointerdown', event => {
          if (details.open && !this.contains(event.target)) details.open = false;
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || !details.open) return;
          event.preventDefault();
          event.stopPropagation();
          details.open = false;
          details.querySelector('summary').focus();
        }, options);
        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) details.open = false;
        }, options);
      }
      this.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (!link || !this.contains(link)) return;
        if (details) details.open = false;
        if (link.hasAttribute('data-mnl-catalog-anchor')) {
          this.closest('.mnl-hd-drawer--menu')?.querySelector('[data-mnl-close]')?.click();
        }
      }, options);
    }
    disconnectedCallback() {
      this.catalogAbort?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-instagram-feed"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mnl-instagram-feed')) {
    customElements.define('mnl-instagram-feed', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.list = this.querySelector('[data-ig-list]');
        this.prev = this.querySelector('[data-ig-prev]');
        this.next = this.querySelector('[data-ig-next]');
        this.controls = this.querySelector('[data-ig-controls]');
        this.viewport = this.querySelector('[data-ig-viewport]');
        this.fallback = this.querySelector('[data-ig-fallback]');
        this.events = new AbortController();
        const options = {signal:this.events.signal};
        this.prev.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.list.addEventListener('scroll', () => this.updateNavigation(), {passive:true, ...options});
        if ('ResizeObserver' in window) {
          this.resize = new ResizeObserver(() => this.updateNavigation());
          this.resize.observe(this.list);
        }
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.observer.disconnect();
              this.load();
            }
          }, {rootMargin:'700px 0px'});
          this.observer.observe(this);
        } else this.load();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.resize?.disconnect();
        this.events?.abort();
        this.request?.abort();
        this.initialized = false;
        this.loadStarted = false;
      }
      safeUrl(value, media) {
        try {
          const url = new URL(value);
          if (url.protocol !== 'https:' || url.username || url.password || url.port) return '';
          if (media) return /(^|\.)(cdninstagram\.com|fbcdn\.net)$/.test(url.hostname) ? url.href : '';
          return /^(www\.)?instagram\.com$/.test(url.hostname) && /^\/(p|reel|tv)\/[A-Za-z0-9_-]+\/?$/.test(url.pathname) ? url.href : '';
        } catch { return ''; }
      }
      async load() {
        if (this.loadStarted || !this.isConnected) return;
        this.loadStarted = true;
        this.request?.abort();
        const request = this.request = new AbortController();
        const timer = setTimeout(() => request.abort(), 12000);
        try {
          const endpoint = this.dataset.endpoint;
          if (endpoint !== 'https://mynutrilab-ai.vercel.app/api/instagram-feed') return;
          const response = await fetch(endpoint, {credentials:'omit', signal:request.signal, referrerPolicy:'no-referrer'});
          if (!response.ok) return;
          const data = await response.json();
          if (!data || data.status !== 'ok' || data.username !== 'mynutrilab_' || !Array.isArray(data.posts) || !this.isConnected || request.signal.aborted || this.request !== request) return;
          const fragment = document.createDocumentFragment();
          const seen = new Set();
          for (const post of data.posts.slice(0,8)) {
            if (!post || typeof post !== 'object') continue;
            const href = this.safeUrl(post.permalink, false);
            const source = this.safeUrl(post.imageUrl, true);
            if (!href || !source || seen.has(href) || !['IMAGE','VIDEO','CAROUSEL_ALBUM'].includes(post.type)) continue;
            seen.add(href);
            const li = document.createElement('li'); li.className = 'mnl-ig__item';
            const link = document.createElement('a'); link.className = 'mnl-ig__post'; link.href = href; link.target = '_blank'; link.rel = 'noopener noreferrer';
            const caption = String(post.caption || '').slice(0,320);
            const kind = post.type === 'VIDEO' ? this.dataset.video : post.type === 'CAROUSEL_ALBUM' ? this.dataset.album : this.dataset.photo;
            link.setAttribute('aria-label', this.dataset.open + ' — ' + (caption || kind));
            const media = document.createElement('div'); media.className = 'mnl-ig__media';
            const img = document.createElement('img'); img.className = 'mnl-ig__image'; img.src = source; img.width = 480; img.height = 600; img.loading = 'lazy'; img.decoding = 'async'; img.alt = ''; img.referrerPolicy = 'no-referrer';
            img.addEventListener('error', () => { li.remove(); this.updateNavigation(); if(!this.list.children.length){this.viewport.hidden = true; this.fallback.hidden = false;} }, {once:true});
            media.append(img);
            const badge = document.createElement('span'); badge.className = 'mnl-ig__kind'; badge.textContent = kind; media.append(badge);
            const arrow = document.createElement('span'); arrow.className = 'mnl-ig__play'; arrow.textContent = post.type === 'VIDEO' ? '▶' : '↗'; arrow.setAttribute('aria-hidden','true'); media.append(arrow);
            const text = document.createElement('p'); text.className = 'mnl-ig__caption'; text.textContent = caption || this.dataset.open;
            link.append(media,text); li.append(link); fragment.append(li);
          }
          if (!fragment.children.length) return;
          this.list.replaceChildren(fragment);
          this.viewport.hidden = false;
          this.fallback.hidden = true;
          requestAnimationFrame(() => this.updateNavigation());
        } catch {} finally { clearTimeout(timer); }
      }
      updateNavigation() {
        if (!this.list) return;
        const max = this.list.scrollWidth - this.list.clientWidth;
        this.controls.hidden = max < 4;
        this.prev.disabled = this.list.scrollLeft <= 2;
        this.next.disabled = this.list.scrollLeft >= max - 2;
      }
      move(direction) {
        this.list.scrollBy({left:direction * (this.list.firstElementChild?.getBoundingClientRect().width + 16 || this.list.clientWidth), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-intelligent-start"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mnl-intelligent-start')) {
  customElements.define('mnl-intelligent-start', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      const tabs = Array.from(this.querySelectorAll('[data-intent-tab]'));
      const panels = Array.from(this.querySelectorAll('[data-intent-panel]'));
      const list = this.querySelector('[data-intent-tabs]');
      if (!list || tabs.length !== 2 || panels.length !== 2 || tabs.some((tab,index) => tab.dataset.intentTab !== panels[index].dataset.intentPanel || tab.getAttribute('aria-controls') !== panels[index].id)) return;
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      list.setAttribute('role','tablist');
      tabs.forEach((tab,index) => {
        tab.setAttribute('role','tab');
        panels[index].setAttribute('role','tabpanel');
        panels[index].setAttribute('aria-labelledby',tab.id);
        tab.addEventListener('click',() => this.activate(index),options);
        tab.addEventListener('keydown',event => {
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          let next;
          if (event.key === 'ArrowRight') next = (index + direction + tabs.length) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - direction + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          this.activate(next);
          tabs[next].focus();
        },options);
      });
      this.tabs = tabs;
      this.panels = panels;
      const selected = Math.max(0,tabs.findIndex(tab => tab.dataset.intentTab === this.dataset.intent));
      this.activate(selected);
      list.hidden = false;
      this.setAttribute('data-enhanced','');
    }
    activate(index) {
      if (!this.tabs?.[index] || !this.panels?.[index]) return;
      this.tabs.forEach((tab,current) => {
        const selected = current === index;
        tab.setAttribute('aria-selected',String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.panels[current].hidden = !selected;
      });
      this.dataset.intent = this.tabs[index].dataset.intentTab;
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-jar-journey"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mnl-jar-journey')) {
  customElements.define('mnl-jar-journey', class extends HTMLElement {
    static get observedAttributes() { return ['data-studio-focus','data-studio-interactive']; }
    connectedCallback() {
      if (this.controller) { this.sync(); return; }
      this.controller = new AbortController();
      this.querySelectorAll('[data-label-copy]').forEach(node => {
        const text = (window.MNL_CFG_BOOT || {}).labelEditionCopy?.[node.dataset.labelCopy];
        if (typeof text === 'string') {
          node.textContent = text;
          node.closest('[data-studio-anchor="edition"]')?.setAttribute('aria-label',text);
        }
      });
      this.list = this.querySelector('[data-journey-list]');
      this.details = this.querySelector('[data-journey-composition]');
      this.signature = '';
      this.lastFocus = null;
      if (this.details) this.details.open = false;
      this.observer = new MutationObserver(() => this.sync());
      this.observeSources();
      document.addEventListener('input', event => { if (event.target?.id === 'mnl-name') this.sync(); }, {signal:this.controller.signal});
      this.sync();
      if (window.MNLStudioV1502 && typeof window.MNLStudioV1502.boot === 'function') window.MNLStudioV1502.boot(this);
    }
    attributeChangedCallback() { if (this.controller) this.sync(); }
    disconnectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) return;
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.sources = null;
      });
    }
    observeSources() {
      const sources = ['mnl-side-r-actifs-list','mnl-doses-count','mnl-side-r-flavor','mnl-step-summary-5'].map(id => document.getElementById(id));
      if (this.sources && sources.every((source,index) => source === this.sources[index])) return;
      this.observer.disconnect();
      this.sources = sources;
      sources.filter(Boolean).forEach(source => this.observer.observe(source,{childList:true,subtree:true,characterData:true}));
    }
    sync() {
      if (!this.isConnected || !this.controller) return;
      this.observeSources();
      const focus = this.dataset.studioFocus;
      if (focus !== this.lastFocus) {
        if (this.details) this.details.open = false;
        this.lastFocus = focus;
      }
      const title = this.querySelector('[data-journey-title]');
      const canvas = this.querySelector('[data-studio-canvas]');
      const label = this.getAttribute('data-focus-' + focus) || this.dataset.focusComposition;
      if (title && title.textContent !== label) title.textContent = label;
      if (canvas) canvas.setAttribute('aria-label',label);
      const interactive = this.hasAttribute('data-studio-interactive');
      const controls = this.querySelector('.mnl-jar-journey__interactive');
      if (controls) controls.hidden = !interactive;
      if (this.details) this.details.hidden = focus !== 'composition' && !interactive;
      const read = source => source?.textContent.trim() || '—';
      const flavor = read(this.sources[2]).toLocaleLowerCase('fr-FR');
      const color = /framboise|raspberry/.test(flavor) ? 'blue' : /pastèque|watermelon/.test(flavor) ? 'watermelon' : /citron|lemon/.test(flavor) ? 'lemon' : /cola/.test(flavor) ? 'cola' : 'tea';
      if (this.dataset.journeyFlavor !== color) this.dataset.journeyFlavor = color;
      const rows = Array.from(this.sources[0]?.querySelectorAll('li') || []).slice(0,11).map(row => ({name:read(row.querySelector('span')),dose:read(row.querySelector('strong'))})).filter(row => row.name !== '—' && row.dose !== '—');
      const signature = JSON.stringify(rows);
      if (signature !== this.signature) {
        const fragment = document.createDocumentFragment();
        rows.forEach(row => {
          const item = document.createElement('li'), name = document.createElement('span'), dose = document.createElement('strong');
          name.textContent = row.name;
          dose.textContent = row.dose;
          item.append(name,dose);
          fragment.append(item);
        });
        this.list?.replaceChildren(fragment);
        this.signature = signature;
      }
      const empty = this.querySelector('[data-journey-empty]');
      if (empty) empty.hidden = !!rows.length;
      const value = this.querySelector('[data-journey-value]');
      if (value) {
        value.hidden = focus === 'composition' || focus === 'whole' || interactive;
        const text = focus === 'format' ? read(this.sources[1]) + ' ' + this.dataset.dosesLabel : focus === 'name' ? (document.getElementById('mnl-name')?.value.trim() || this.dataset.defaultName) : read(this.sources[2]);
        if (value.textContent !== text) value.textContent = text;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-mobile-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mnl-menu-highlights')) {
  customElements.define('mnl-menu-highlights', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._track = this.querySelector('[data-mnl-highlights-track]');
      this._cards = Array.from(this.querySelectorAll('[data-mnl-highlight-slide]'));
      this._controls = this.querySelector('[data-mnl-highlight-controls]');
      this._previous = this.querySelector('[data-mnl-highlight-previous]');
      this._next = this.querySelector('[data-mnl-highlight-next]');
      this._count = this.querySelector('[data-mnl-highlight-count]');
      if (!this._track || this._cards.length < 2 || !this._controls || !this._previous || !this._next || !this._count) return;
      this._controller = new AbortController();
      const signal = this._controller.signal;
      this._controls.hidden = false;
      this._previous.addEventListener('click', () => this._goTo(this._currentIndex() - 1), {signal});
      this._next.addEventListener('click', () => this._goTo(this._currentIndex() + 1), {signal});
      this._track.addEventListener('scroll', () => this._queueSync(), {passive:true, signal});
      this._track.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        const rtl = getComputedStyle(this._track).direction === 'rtl';
        let index;
        if (event.key === 'ArrowRight') index = this._currentIndex() + (rtl ? -1 : 1);
        else if (event.key === 'ArrowLeft') index = this._currentIndex() + (rtl ? 1 : -1);
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this._cards.length - 1;
        else return;
        event.preventDefault();
        this._goTo(index, true);
      }, {signal});
      window.addEventListener('resize', () => this._queueSync(), {passive:true, signal});
      if (typeof ResizeObserver !== 'undefined') {
        this._observer = new ResizeObserver(() => this._queueSync());
        this._observer.observe(this._track);
      }
      this._sync();
    }
    _currentIndex() {
      const position = Math.abs(this._track.scrollLeft);
      const maximum = Math.max(0, this._track.scrollWidth - this._track.clientWidth);
      if (position <= 2 || maximum <= 2) return 0;
      if (position >= maximum - 2) return this._cards.length - 1;
      const origin = this._cards[0].offsetLeft;
      let nearest = 0;
      let distance = Infinity;
      this._cards.forEach((card, index) => {
        const delta = Math.abs(Math.abs(card.offsetLeft - origin) - position);
        if (delta < distance) { nearest = index; distance = delta; }
      });
      return nearest;
    }
    _goTo(index, focusCard = false) {
      const target = Math.max(0, Math.min(this._cards.length - 1, index));
      const distance = Math.abs(this._cards[target].offsetLeft - this._cards[0].offsetLeft);
      const rtl = getComputedStyle(this._track).direction === 'rtl';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (focusCard) this._cards[target].querySelector('a')?.focus({preventScroll:true});
      this._track.scrollTo({left:rtl ? -distance : distance, behavior:reduced ? 'auto' : 'smooth'});
      this._queueSync();
    }
    _queueSync() {
      if (this._frame != null) return;
      this._frame = requestAnimationFrame(() => {this._frame = null; this._sync();});
    }
    _sync() {
      const index = this._currentIndex();
      const overflow = this._track.scrollWidth - this._track.clientWidth > 2;
      this._previous.disabled = !overflow || index === 0;
      this._next.disabled = !overflow || index === this._cards.length - 1;
      this._count.textContent = (index + 1) + ' / ' + this._cards.length;
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      this._observer = null;
      if (this._frame != null) cancelAnimationFrame(this._frame);
      this._frame = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-step-ingredient-animation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mnl-step-ingredient-animation')) {
  customElements.define('mnl-step-ingredient-animation', class extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.ready = false;
      this.inView = !('IntersectionObserver' in window);
      this.paused = this.paused || false;
      this.index = this.index || 0;
      this.elapsed = this.elapsed || 0;
      this.base = this.querySelector('.mnl-step-ingredient-animation__base-loader');
      this.grains = this.querySelector('.mnl-step-ingredient-animation__powder-loader');
      this.powder = this.querySelector('[data-ingredient-powder]');
      this.powderWindow = this.querySelector('[data-ingredient-powder-window]');
      this.caption = this.querySelector('.mnl-step-ingredient-animation__caption');
      this.nameLine = this.querySelector('[data-ingredient-name]');
      this.roleLine = this.querySelector('[data-ingredient-role]');
      this.button = this.querySelector('.mnl-step-ingredient-animation__toggle');
      try {
        this.ingredients = JSON.parse(this.dataset.ingredientExamples).map(example => example.split('~')).filter(parts => parts.length === 2 && parts.every(part => part.length > 0 && part.length <= 100));
      } catch {
        this.ingredients = [];
      }
      if (!this.base || !this.grains || !this.powder || !this.powderWindow || !this.caption || !this.nameLine || !this.roleLine || !this.button || this.ingredients.length < 2) {
        this.connected = false;
        return;
      }
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onReady = () => {
        if (!this.connected || !this.base.complete || !this.base.naturalWidth || !this.grains.complete || !this.grains.naturalWidth) return;
        this.querySelector('[data-ingredient-base-image]').setAttribute('href', this.base.currentSrc || this.base.src);
        this.querySelector('[data-ingredient-front-image]').setAttribute('href', this.base.currentSrc || this.base.src);
        this.querySelector('[data-ingredient-powder-image]').setAttribute('href', this.grains.currentSrc || this.grains.src);
        this.ready = true;
        this.removeAttribute('data-failed');
        this.setAttribute('data-ready', '');
        this.caption.hidden = false;
        this.updateIngredient();
        this.sync();
      };
      this.onError = () => {
        this.ready = false;
        this.removeAttribute('data-ready');
        this.setAttribute('data-failed', '');
        this.caption.hidden = true;
        this.sync();
      };
      this.onToggle = () => {
        this.paused = !this.paused;
        this.sync();
      };
      this.onEnvironment = () => this.sync();
      this.base.addEventListener('load', this.onReady);
      this.base.addEventListener('error', this.onError);
      this.grains.addEventListener('load', this.onReady);
      this.grains.addEventListener('error', this.onError);
      this.button.addEventListener('click', this.onToggle);
      document.addEventListener('visibilitychange', this.onEnvironment);
      this.motion.addEventListener('change', this.onEnvironment);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.15);
          this.sync();
        }, { threshold: 0.15 });
        this.observer.observe(this);
      }
      if (this.base.complete && this.base.naturalWidth && this.grains.complete && this.grains.naturalWidth) this.onReady();
      else this.sync();
    }
    disconnectedCallback() {
      this.connected = false;
      this.cancelCycle(true);
      if (this.observer) this.observer.disconnect();
      if (this.base) {
        this.base.removeEventListener('load', this.onReady);
        this.base.removeEventListener('error', this.onError);
      }
      if (this.grains) {
        this.grains.removeEventListener('load', this.onReady);
        this.grains.removeEventListener('error', this.onError);
      }
      if (this.button) {
        this.button.removeEventListener('click', this.onToggle);
        this.button.hidden = true;
      }
      document.removeEventListener('visibilitychange', this.onEnvironment);
      if (this.motion) this.motion.removeEventListener('change', this.onEnvironment);
    }
    updateIngredient() {
      const ingredient = this.ingredients[this.index % this.ingredients.length];
      const frame = this.index % 5;
      this.powderWindow.setAttribute('viewBox', `${(frame % 3) * 256} ${Math.floor(frame / 3) * 256} 256 256`);
      this.nameLine.textContent = ingredient[0];
      this.roleLine.textContent = ingredient[1];
      this.dataset.ingredientIndex = String(this.index);
    }
    cancelCycle(rememberTime) {
      if (!this.animation) return;
      this.elapsed = rememberTime && typeof this.animation.currentTime === 'number' ? this.animation.currentTime : 0;
      this.animation.onfinish = null;
      this.animation.cancel();
      this.animation = null;
    }
    beginCycle() {
      const [x, y, angle, drift, turn] = [
        [0, 0, -1.8, -5, 2.3],
        [-5, 2, 1.5, 6, -2.2],
        [4, -2, -0.8, -4, -2],
        [-3, -1, 2.1, 4, 2.4],
        [3, 2, -2.2, 7, 1.8]
      ][this.index % 5];
      const held = `translate(${x}px, ${y}px) rotate(${angle}deg)`;
      const dropped = `translate(${x + drift}px, ${y + 260}px) rotate(${angle + turn}deg)`;
      this.animation = this.powder.animate([
        { offset: 0, transform: `translate(${x}px, ${y - 8}px) rotate(${angle}deg)`, opacity: 0 },
        { offset: 60 / 2350, transform: held, opacity: 1 },
        { offset: 1900 / 2350, transform: held, opacity: 1, easing: 'cubic-bezier(.4,0,.8,.6)' },
        { offset: 2300 / 2350, transform: dropped, opacity: 1 },
        { offset: 1, transform: dropped, opacity: 0 }
      ], { duration: 2350, fill: 'both', easing: 'linear' });
      this.animation.pause();
      this.animation.currentTime = Math.min(this.elapsed, 2349);
      this.animation.onfinish = () => {
        if (!this.connected || !this.ready || this.motion.matches) return;
        this.cancelCycle(false);
        this.index = (this.index + 1) % this.ingredients.length;
        this.updateIngredient();
        this.sync();
      };
    }
    sync() {
      if (!this.connected || !this.button || !this.motion) return;
      const staticView = this.motion.matches || typeof this.powder.animate !== 'function';
      this.button.hidden = !this.ready || staticView;
      this.button.setAttribute('aria-pressed', String(this.paused));
      this.button.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      if (!this.ready) {
        if (this.animation) this.animation.pause();
        this.dataset.motionState = 'unavailable';
        return;
      }
      if (staticView) {
        this.cancelCycle(false);
        this.elapsed = 0;
        this.index = 0;
        this.updateIngredient();
        this.dataset.motionState = 'static';
        return;
      }
      if (!this.animation) this.beginCycle();
      if (this.inView && !this.paused && !document.hidden) {
        this.animation.play();
        this.dataset.motionState = 'playing';
      } else {
        this.animation.pause();
        this.dataset.motionState = 'paused';
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-step-name-animation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mnl-step-name-animation')) {
  customElements.define('mnl-step-name-animation', class extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.ready = false;
      this.inView = !('IntersectionObserver' in window);
      this.paused = this.paused || false;
      this.index = this.index || 0;
      this.elapsed = this.elapsed || 0;
      this.clean = this.querySelector('.mnl-step-name-animation__clean');
      this.button = this.querySelector('.mnl-step-name-animation__toggle');
      this.firstLine = this.querySelector('[data-name-first]');
      this.secondLine = this.querySelector('[data-name-second]');
      this.firstLayer = this.querySelector('[data-name-line="first"]');
      this.secondLayer = this.querySelector('[data-name-line="second"]');
      try {
        this.names = JSON.parse(this.dataset.nameExamples).map(name => name.split('~')).filter(parts => parts.length === 2 && parts.every(part => part.length > 0 && part.length <= 12));
      } catch {
        this.names = [];
      }
      if (!this.clean || !this.button || !this.firstLine || !this.secondLine || !this.firstLayer || !this.secondLayer || this.names.length < 2) {
        this.connected = false;
        return;
      }
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onReady = () => {
        if (!this.connected || !this.clean.naturalWidth) return;
        this.ready = true;
        this.removeAttribute('data-failed');
        this.setAttribute('data-ready', '');
        this.updateName();
        this.sync();
      };
      this.onError = () => {
        this.ready = false;
        this.removeAttribute('data-ready');
        this.setAttribute('data-failed', '');
        this.sync();
      };
      this.onToggle = () => {
        this.paused = !this.paused;
        this.sync();
      };
      this.onEnvironment = () => {
        if (this.staticView()) {
          this.index = 0;
          this.updateName();
        }
        this.sync();
      };
      this.clean.addEventListener('load', this.onReady);
      this.clean.addEventListener('error', this.onError);
      this.button.addEventListener('click', this.onToggle);
      document.addEventListener('visibilitychange', this.onEnvironment);
      this.motion.addEventListener('change', this.onEnvironment);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.15);
          this.sync();
        }, { threshold: 0.15 });
        this.observer.observe(this);
      }
      if (this.staticView()) this.index = 0;
      this.updateName();
      if (this.clean.complete && this.clean.naturalWidth) this.onReady();
      else this.sync();
    }
    disconnectedCallback() {
      this.connected = false;
      this.cancelCycle(true);
      if (this.observer) this.observer.disconnect();
      this.observer = null;
      if (this.clean) {
        this.clean.removeEventListener('load', this.onReady);
        this.clean.removeEventListener('error', this.onError);
      }
      if (this.button) {
        this.button.removeEventListener('click', this.onToggle);
        this.button.hidden = true;
      }
      document.removeEventListener('visibilitychange', this.onEnvironment);
      if (this.motion) this.motion.removeEventListener('change', this.onEnvironment);
    }
    updateName() {
      const name = this.names[this.index % this.names.length];
      this.firstLine.textContent = name[0];
      this.secondLine.textContent = name[1];
    }
    staticView() {
      return this.motion.matches || typeof this.firstLayer.animate !== 'function' || typeof this.secondLayer.animate !== 'function';
    }
    cancelCycle(rememberTime = false) {
      if (rememberTime && this.firstAnimation && typeof this.firstAnimation.currentTime === 'number') this.elapsed = this.firstAnimation.currentTime;
      if (!rememberTime) this.elapsed = 0;
      for (const animation of [this.firstAnimation, this.secondAnimation]) {
        if (!animation) continue;
        animation.onfinish = null;
        animation.cancel();
      }
      this.firstAnimation = null;
      this.secondAnimation = null;
    }
    beginCycle() {
      if (this.firstAnimation || !this.connected || !this.ready || this.staticView()) return;
      const duration = 2100;
      const options = { duration, easing: 'linear', fill: 'both' };
      this.firstAnimation = this.firstLayer.animate([
        { transform: 'translateY(22px)', opacity: 0, offset: 0, easing: 'cubic-bezier(.2,.7,.3,1)' },
        { transform: 'translateY(-2px)', opacity: 1, offset: 180 / duration },
        { transform: 'translateY(0px)', opacity: 1, offset: 300 / duration },
        { transform: 'translateY(0px)', opacity: 1, offset: 1960 / duration, easing: 'ease-in' },
        { transform: 'translateY(-14px)', opacity: 0, offset: 1 }
      ], options);
      this.secondAnimation = this.secondLayer.animate([
        { transform: 'translateY(22px)', opacity: 0, offset: 0 },
        { transform: 'translateY(22px)', opacity: 0, offset: 70 / duration, easing: 'cubic-bezier(.2,.7,.3,1)' },
        { transform: 'translateY(-2px)', opacity: 1, offset: 250 / duration },
        { transform: 'translateY(0px)', opacity: 1, offset: 400 / duration },
        { transform: 'translateY(0px)', opacity: 1, offset: 1960 / duration, easing: 'ease-in' },
        { transform: 'translateY(-14px)', opacity: 0, offset: 1 }
      ], options);
      const primary = this.firstAnimation;
      primary.onfinish = () => {
        if (!this.connected || this.firstAnimation !== primary) return;
        this.cancelCycle();
        this.index = (this.index + 1) % this.names.length;
        this.updateName();
        this.sync();
      };
      const time = Math.max(0, Math.min(this.elapsed, duration - 1));
      for (const animation of [this.firstAnimation, this.secondAnimation]) {
        animation.pause();
        animation.currentTime = time;
      }
    }
    sync() {
      if (!this.connected || !this.button || !this.motion) return;
      const staticView = this.staticView();
      this.button.hidden = !this.ready || staticView;
      this.button.setAttribute('aria-pressed', String(this.paused));
      this.button.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      if (staticView) {
        this.cancelCycle();
        this.index = 0;
        this.updateName();
        return;
      }
      if (this.ready) this.beginCycle();
      if (!this.firstAnimation) return;
      const running = this.ready && this.inView && !this.paused && !document.hidden;
      if (running) {
        if (this.firstAnimation.playState !== 'running') {
          this.firstAnimation.play();
          this.secondAnimation.play();
        }
      } else {
        this.firstAnimation.pause();
        this.secondAnimation.pause();
        if (typeof this.firstAnimation.currentTime === 'number') this.elapsed = this.firstAnimation.currentTime;
        this.secondAnimation.currentTime = this.firstAnimation.currentTime;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mnl-studio-reader-behavior-v1488"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  var win = window;
  var doc = document;
  var key = 'MNLStudioReaderV1488';
  if (win[key]) {
    win[key].scan(doc);
    return;
  }
  var records = new Map();
  var paused = false;
  var destroyed = false;
  function owned(root, selector) {
    var nodes = root.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].closest('[data-mnl-studio]') === root) return nodes[i];
    }
    return null;
  }
  function text(value) {
    return String(value == null ? '' : value).trim();
  }
  function mount(root) {
    var details = owned(root, '[data-studio-reader]');
    var existing = records.get(root);
    if (existing && existing.details !== details) {
      existing.destroy();
      records.delete(root);
      existing = null;
    }
    if (!details || root.isConnected === false) return;
    if (existing) {
      existing.refresh();
      return;
    }
    var fields = [];
    var stopped = false;
    var observer = typeof win.MutationObserver === 'function' ? new win.MutationObserver(sync) : null;
    function sync() {
      if (stopped || paused || destroyed || root.isConnected === false) return;
      fields.forEach(function (field) {
        var value = field.source ? text(field.source.textContent) : field.rootDefault ? text(root.getAttribute('data-default-name')) : '';
        if (!value || value === '—') value = field.fallback;
        if (field.output.textContent !== value) field.output.textContent = value;
      });
    }
    function refresh() {
      if (stopped || paused || destroyed) return;
      if (observer) observer.disconnect();
      fields = [];
      var watched = new Set();
      var context = root.getAttribute('data-context');
      ['name', 'format', 'flavor'].forEach(function (name) {
        var output = owned(root, '[data-studio-reader-' + name + ']');
        if (!output || !details.contains(output)) return;
        var source = null;
        if (name === 'name' && context === 'home') source = owned(root, '[data-studio-preview-output]');
        else if (context === 'config') source = owned(root, '[data-studio-' + name + ']');
        if (source && details.contains(source)) source = null;
        var fallback = text(output.getAttribute('data-reader-default'));
        fields.push({ output: output, source: source, fallback: fallback, rootDefault: name === 'name' && context !== 'home' && context !== 'config' });
        if (observer && source && !watched.has(source)) {
          watched.add(source);
          observer.observe(source, { childList: true, characterData: true, subtree: true });
        }
      });
      sync();
    }
    function toggle() {
      refresh();
    }
    function stop() {
      if (stopped) return;
      stopped = true;
      if (observer) observer.disconnect();
      details.removeEventListener('toggle', toggle);
      fields = [];
    }
    details.addEventListener('toggle', toggle);
    records.set(root, { details: details, refresh: refresh, pause: function () { if (observer) observer.disconnect(); }, destroy: stop });
    refresh();
  }
  function scan(scope) {
    if (destroyed) return;
    records.forEach(function (record, root) {
      if (root.isConnected === false) {
        record.destroy();
        records.delete(root);
      }
    });
    if (paused) return;
    scope = scope || doc;
    if (scope.matches && scope.matches('[data-mnl-studio]')) mount(scope);
    if (scope.querySelectorAll) {
      var roots = scope.querySelectorAll('[data-mnl-studio]');
      for (var i = 0; i < roots.length; i++) mount(roots[i]);
    }
  }
  function ready() {
    doc.removeEventListener('DOMContentLoaded', ready);
    scan(doc);
  }
  function sectionLoad(event) {
    scan(event.target || doc);
  }
  function readerToggle(event) {
    if (paused || destroyed) return;
    var details = event.target;
    if (!details || !details.matches || !details.matches('[data-studio-reader]')) return;
    var root = details.closest('[data-mnl-studio]');
    if (root && owned(root, '[data-studio-reader]') === details) mount(root);
  }
  function sectionUnload(event) {
    var scope = event.target;
    records.forEach(function (record, root) {
      if (root.isConnected === false || root === scope || (scope && scope.contains && scope.contains(root))) {
        record.destroy();
        records.delete(root);
      }
    });
  }
  function pageHide(event) {
    if (event.persisted) {
      paused = true;
      records.forEach(function (record) { record.pause(); });
    } else {
      destroy();
    }
  }
  function pageShow(event) {
    if (!event.persisted || destroyed) return;
    paused = false;
    scan(doc);
  }
  function destroy() {
    if (destroyed) return;
    destroyed = true;
    records.forEach(function (record) { record.destroy(); });
    records.clear();
    doc.removeEventListener('DOMContentLoaded', ready);
    doc.removeEventListener('toggle', readerToggle, true);
    doc.removeEventListener('shopify:section:load', sectionLoad);
    doc.removeEventListener('shopify:section:unload', sectionUnload);
    win.removeEventListener('pagehide', pageHide);
    win.removeEventListener('pageshow', pageShow);
    if (win[key] === api) delete win[key];
  }
  var api = { scan: scan, destroy: destroy };
  win[key] = api;
  doc.addEventListener('toggle', readerToggle, true);
  doc.addEventListener('shopify:section:load', sectionLoad);
  doc.addEventListener('shopify:section:unload', sectionUnload);
  win.addEventListener('pagehide', pageHide);
  win.addEventListener('pageshow', pageShow);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', ready);
  else scan(doc);
})();
  } catch(e) { console.error(e); }
})();

})();
